import React, { Component } from 'react';
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "../../modules/Grid/GridItem.jsx";
import GridContainer from "../../modules/Grid/GridContainer.jsx";
import Table from "../../modules/Table/Table.jsx";
import CustomTabs from "../../modules/CustomTabs/CustomTabs.jsx";
import Card from "../../modules/Card/Card.jsx";
import CardHeader from "../../modules/Card/CardHeader.jsx";
import CardIcon from "../../modules/Card/CardIcon.jsx";
import CardBody from "../../modules/Card/CardBody.jsx";
import CardFooter from "../../modules/Card/CardFooter.jsx";
import dashboardStyle from "../../modules/jss/dashboardStyle.jsx";

// @material-ui/icons
import Store from "@material-ui/icons/Store";
import AccessAlarm from "@material-ui/icons/AccessAlarm";
import Backup from "@material-ui/icons/Backup";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import Cancel from "@material-ui/icons/Cancel";

import { projectActions, tasksissuesActions } from '../../_actions';
import { connect } from 'react-redux';
import { compose } from "recompose";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            AnalysisData: [],
            AnalysisProjectsData: [],
        };
    }

    componentDidMount() {
        this.props.dispatch(projectActions.getAllByUserId(this.props.user.id));
        this.props.dispatch(tasksissuesActions.getAllByUserId(this.props.user.id));
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            data: nextProps.props,
        });

        if (nextProps.tasksissues && nextProps.tasksissues.items) {
            this.setState({
                AnalysisData: calculateData(nextProps.tasksissues.items, this.props.user)
            });
        }

        if (nextProps.projects && nextProps.projects.items) {
            this.setState({
                AnalysisProjectsData: calculateProjectsData(nextProps.projects.items, nextProps.tasksissues.items, this.props.user)
            });
        }
    }

    render() {
        const { classes } = this.props;
        const status1DataArray = this.state.AnalysisData.status1DataArray === undefined ? [] : this.state.AnalysisData.status1DataArray;
        const status2DataArray = this.state.AnalysisData.status2DataArray === undefined ? [] : this.state.AnalysisData.status2DataArray;
        const status3DataArray = this.state.AnalysisData.status3DataArray === undefined ? [] : this.state.AnalysisData.status3DataArray;
        const status4DataArray = this.state.AnalysisData.status4DataArray === undefined ? [] : this.state.AnalysisData.status4DataArray;
        const AnalysisProjectsData = this.state.AnalysisProjectsData.arrayList === undefined ? [] : this.state.AnalysisProjectsData.arrayList;

        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader color="warning" stats icon>
                                <CardIcon color="warning">
                                    <AccessAlarm />
                                </CardIcon>
                                <p className={classes.cardCategory}>Pending Tasks</p>
                                <h1 className={classes.cardTitle}>{this.state.AnalysisData.status1}</h1>
                            </CardHeader>
                            <CardFooter stats>
                                <div className={classes.stats}>
                                    {/* <Danger>
                                        <Warning />
                                    </Danger> */}
                                </div>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader color="success" stats icon>
                                <CardIcon color="success">
                                    <Store />
                                </CardIcon>
                                <p className={classes.cardCategory}>In-Progress Tasks</p>
                                <h1 className={classes.cardTitle}>{this.state.AnalysisData.status2}</h1>
                            </CardHeader>
                            <CardFooter stats>
                                {/* <div className={classes.stats}>
                                    <DateRange /> Last 24 Hours
                                </div> */}
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader color="danger" stats icon>
                                <CardIcon color="danger">
                                    <Backup />
                                </CardIcon>
                                <p className={classes.cardCategory}>Completed Tasks</p>
                                <h1 className={classes.cardTitle}>{this.state.AnalysisData.status3}</h1>
                            </CardHeader>
                            <CardFooter stats>
                                {/* <div className={classes.stats}>
                                    <LocalOffer /> Tracked from Hunter Game
                                </div> */}
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <Card>
                            <CardHeader color="primary" stats icon>
                                <CardIcon color="primary">
                                    <Accessibility />
                                </CardIcon>
                                <p className={classes.cardCategory}>Cancelled Tasks</p>
                                <h1 className={classes.cardTitle}>{this.state.AnalysisData.status4}</h1>
                            </CardHeader>
                            <CardFooter stats>
                                {/* <div className={classes.stats}>
                                    <Update /> Just Updated
                                </div> */}
                            </CardFooter>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem sm={12} md={6}>
                        <CustomTabs
                            title="Tasks:"
                            headerColor="info"
                            tabs={[
                                {
                                    tabName: "Pending",
                                    tabIcon: BugReport,
                                    tabContent: (
                                        <Table
                                            tableHeaderColor="warning"
                                            tableHead={["Task Name", "Task Notes", "Project"]}
                                            tableData={status1DataArray}
                                        />
                                    )
                                },
                                {
                                    tabName: "In-Progress",
                                    tabIcon: Code,
                                    tabContent: (
                                        <Table
                                            tableHeaderColor="warning"
                                            tableHead={["Task Name", "Task Notes", "Project"]}
                                            tableData={status2DataArray}
                                        />
                                    )
                                },
                                {
                                    tabName: "Completed",
                                    tabIcon: Cloud,
                                    tabContent: (
                                        <Table
                                            tableHeaderColor="warning"
                                            tableHead={["Task Name", "Task Notes", "Project"]}
                                            tableData={status3DataArray}
                                        />
                                    )
                                },
                                {
                                    tabName: "Cancelled",
                                    tabIcon: Cancel,
                                    tabContent: (
                                        <Table
                                            tableHeaderColor="warning"
                                            tableHead={["Task Name", "Task Notes", "Project"]}
                                            tableData={status4DataArray}
                                        />
                                    )
                                }
                            ]}
                        />
                    </GridItem>
                    <GridItem sm={12} md={6}>
                        <Card>
                            <CardHeader color="info">
                                <h4 className={classes.cardTitleWhite}>Projects</h4>
                                <p className={classes.cardCategoryWhite}>Team Projects</p>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="warning"
                                    tableHead={["ID", "Project Name", "Pending Tasks", "In-Progress Tasks", "Completed Tasks", "Cancelled Tasks"]}
                                    tableData={AnalysisProjectsData}
                                />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

function calculateData(tasksissuesData, user) {

    var status1 = 0;
    var status2 = 0;
    var status3 = 0;
    var status4 = 0;
    var status1DataArray = [];
    var status2DataArray = [];
    var status3DataArray = [];
    var status4DataArray = [];

    tasksissuesData.map((data, key) => {

        var status1Data = [];
        var status2Data = [];
        var status3Data = [];
        var status4Data = [];
        if (data.AssignedToId === user.id) {
            switch (data.Status) {
                case 1:
                    status1++;
                    status1Data.push(data.TaskName);
                    status1Data.push(data.TaskNotes);
                    status1Data.push(data.ProjectName);
                    status1DataArray.push(status1Data);
                    break;
                case 2:
                    status2++;
                    status2Data.push(data.TaskName);
                    status2Data.push(data.TaskNotes);
                    status2Data.push(data.ProjectName);
                    status2DataArray.push(status2Data);
                    break;
                case 3:
                    status3++;
                    status3Data.push(data.TaskName);
                    status3Data.push(data.TaskNotes);
                    status3Data.push(data.ProjectName);
                    status3DataArray.push(status3Data);
                    break;
                case 4:
                    status4++;
                    status4Data.push(data.TaskName);
                    status4Data.push(data.TaskNotes);
                    status4Data.push(data.ProjectName);
                    status4DataArray.push(status4Data);
                    break
                default:
                    return null;
            }
        }

        return null;
    })

    return {
        status1: status1,
        status2: status2,
        status3: status3,
        status4: status4,
        status1DataArray: status1DataArray,
        status2DataArray: status2DataArray,
        status3DataArray: status3DataArray,
        status4DataArray: status4DataArray,
    };
}

function calculateProjectsData(projectsData, tasksissuesData, user) {
    var arrayList = [];
    projectsData.map((pData) => {

        var array = [];
        if (pData.ProgressStatus !== '4') {

            var status1 = 0;
            var status2 = 0;
            var status3 = 0;
            var status4 = 0;
            tasksissuesData && tasksissuesData.map(tData => {
                if (tData.ProjectId === pData.ProjectId) {
                    switch (tData.Status) {
                        case 1:
                            status1++;
                            break;
                        case 2:
                            status2++;
                            break;
                        case 3:
                            status3++;
                            break;
                        case 4:
                            status4++;
                            break
                        default:
                            return null;
                    }
                }

                return null;
            })

            array.push(pData.ProjectId.toString());
            array.push(pData.ProjectName);
            array.push(status1.toString());
            array.push(status2.toString());
            array.push(status3.toString());
            array.push(status4.toString());
            arrayList.push(array);
        }

        return null;
    })

    return {
        arrayList: arrayList
    };
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { projects, tasksissues } = state;

    return {
        user,
        projects,
        tasksissues
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired
};

export default compose(connect(mapStateToProps), withStyles(dashboardStyle))(App);


// WEBPACK FOOTER //
// ./src/components/Dashboard/App.js